import React, { useState } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardFooter,
  UncontrolledDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  Tooltip,
  Modal,
  ModalBody,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap";
import {
  Container,
  Row,
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useParams, useLocation } from "react-router-dom";
import { Field, Formik } from "formik";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import plusIcons from "assets/icon/plus-icon.svg";


import moment from "moment";

// import { Field, Formik } from 'formik';
import HoverImage from "react-hover-image/build";
import { cellRendererCheck, dateFormate } from "utils/columns";
import filter from "assets/icon/filter-icon.svg";
import SortArrow from "assets/icon/sort-arrow.svg";
import Plus from "assets/icon/plus-rx.svg";
import Calendar from "assets/icon/calendar-pms.svg";
import admin from "assets/icon/admin-black.svg";
// import Cal from "assets/icon/calendar-pms.svg";
import leftArrow from "assets/icon/left-arrow.svg";
import ScanIcon from "assets/icon/scan-icon.svg";
import drug from "assets/icon/drug-status.svg";
import drugList from "assets/icon/drug-list.svg";
import threeDotsIcon from "assets/icon/3-dots.svg";
// import CloseIcon from "assets/icon/close-icon.svg";
import { useNavigate } from "react-router-dom";
import DrugUtilPopUp from "pages/OrderEntry/DrugUtilPopUp";
import Drawer from "components/Drawer";
import ClaimsInfo from "pages/OrderEntry/ClaimsInfo";
import plusIcon from "assets/icon/plus-icon-add-note.svg";
import uploadIcon from "assets/icon/upload-icon.svg";
import drugPurpleIcon from "assets/icon/drug-status.svg";
import drugLightIcon from "assets/icon/drug-with-reddot.svg";
import drugWhite from "assets/icon/druglist-green.svg";
import searchIcon from "assets/icon/search.svg";
import searchGrayIcon from "assets/icon/search-inactive.svg";
import patientsScanImage from "assets/images/patients-scan.svg";
import ZoomInIcon from "assets/icon/zoom-in-icon.svg";
import ZoomOutIcon from "assets/icon/zoom-out-icon.svg";
import DeleteIcon from "assets/icon/delete-icon.svg";
import PatientsDemographic from "components/PatientsDemographic";
import ReactInputMask from "react-input-mask";
import SearchContainer from "pages/OrderEntry/SearchContainer/Index";
import Confirm from "components/Confirm";
import PrescriptionSummary from "components/PrescriptionSummary";
import Stepper from "react-stepper-horizontal";

import MessageIconDark from "assets/icon/messageIcon-dark.svg";
import MessageIconLight from "assets/icon/messageIcon-light.svg";
import completeIcon from "assets/icon/complete.svg";
import orderDetailsIcon from "assets/icon/order-details-icon.svg";
import SearchContainerOrderEntry from "components/SearchContainerOrderEntry";

import patientProfile from "assets/icon/patient-profile.svg";
import rxHistory from "assets/icon/rx-history-icon.svg";
import upArrow from "assets/inventory/up-arrow.svg";
import downArrow from "assets/inventory/down-arrow.svg";
import plusPurple from "assets/icon/plus-icon-add-note.svg";
import dubbleArrow from "assets/icon/double-arrow-down-purple.svg";
import eidtPurpleIcon from "assets/icon/eidtPurpleIcon.svg";
import deleteIcon from "/assets/icon/delete-white-icon.svg";
import Chating from "pages/OrderEntry/Chating";
import ClaimInformation from "./ClaimInformation";
import CloseIcon from "assets/icon/chatClose.svg";
import aknowledgeIcon from "assets/icon/aknowledge-icon.svg";

// import editIocn from "assets/inventory/edit-icon.svg";
// import deleteIcon from "assets/inventory/delete-icon.svg";
// import CloseIcon from "assets/icon/chatClose.svg";
const ClaimsOrderDetails = ({
  rowData,
  setRowDetails,
  claimInformation,
  setClaimInformation,
  handleClickStatus,
}) => {
  const navigate = useNavigate();
  console.log("rowwwwwwww", rowData);
  const [drugUtil, setDrugUtil] = useState(false);
  const [claimsInfo, setClaimsInfo] = useState(false);
  // const [claimInformation, setClaimInformation] = useState(false);
  const [msgInfo, setMsgInfo] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [startDate, setStartdate] = useState(new Date());
  const [focusedInput, setFocusedInput] = useState("");
  const [openOne, setOpenOne] = useState(false);
  const [openTwo, setOpenTwo] = useState("1");
  const [openThree, setOpenThree] = useState("1");
  const [openPatinetsDetails, setOpenPatinetsDetails] = useState("10");
  const [loading, setLoading] = useState(false);
  const [searchTermDrug, setSearchTermDrug] = useState("");
  const initialImage = patientsScanImage;
  const [openStatus, setOpenStatus] = useState(false);
  const [quantity, setQuantity] = useState("30");
  const [daySupply, setDaySupply] = useState("30");
  const [refills, setRefills] = useState("5");
  const [expand, setExpand] = useState(false);

  const [searchTermPrescriber, setSearchTermPrescriber] = useState({
    medication: "Venlafaxine ER Tablet 150MG",
    prescriber: "ROBERT SMITH, MD",
    dignosis: "",
  });
  const [directions, setDirections] = useState("Take 1 Tablet By Mouth Daily");
  const [tasks, setTasks] = useState([
    { id: 1, task: "Novartis Discount Card" },
    { id: 2, task: "Apply Sliding Scale" },
    { id: 3, task: "340B Cash Card" },
  ]);
  const [newTask, setNewTask] = useState("");
  const [activeNewTask, setActiveNewTask] = useState("");
  const [movedData, setMovedData] = useState([
    {
      id: 4,
      task: "Medicare (Primary)",
    },
    {
      id: 5,
      task: "State Medicaid (Secondary)",
    },
  ]);

  const [selectedOptions, setSelectedOptions] = useState({
    option1: "",
    option2: "",
  });
  const [increment, setIncrement] = useState({
    qty: 30,
    totalQtyWritten: "",
    serialNo: 0,
    partialFillQty: "",
  });

  // const currentStep = 3;
  // const location = useLocation();
  // const rowData = location.state;

  const namesData = {
    fullName: "John Doe",
    firstName: "John",
    lastName: "Doe",
    phone: "(555) 123-4567",
    dob: "01/08/1996 (28 Years)",
  };
  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prevOptions) => ({
      ...prevOptions,
      [name]: value,
    }));
  };
  // Clear individual fields
  const clearSearch = (field) => {
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const handleInputChangePrescriber = (e) => {
    const { name, value } = e.target;
    setSearchTermPrescriber((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDirections = (e) => {
    setDirections(e.target.value);
  };
  const clearSearchPrescriber = () => {
    setSearchTermDrug("");
  };
  const handleChangeIncrement = (e) => {
    const { name, value } = e.target;
    setIncrement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleIncrement = () => {
    setIncrement((prevState) => ({
      ...prevState,
      totalQtyWritten: prevState.totalQtyWritten + 1,
    }));
  };
  const handleDecrement = () => {
    if (increment.totalQtyWritten > 0) {
      setIncrement((prevState) => ({
        ...prevState,
        totalQtyWritten: prevState.totalQtyWritten - 1,
      }));
    }
  };
  const handleAddTask = () => {
    if (newTask.trim() === "") return;
    setTasks([...tasks, { id: Date.now(), task: newTask }]);
    setNewTask("");
  };

  const handleMove = (id) => {
    const move = tasks.find((item) => item.id === id);
    if (move) {
      setMovedData([...movedData, move]);
      setTasks(tasks.filter((item) => item.id !== id));
    }
  };

  const handleDelete = (id) => {
    const del = movedData.filter((item) => item.id !== id);
    setMovedData(del);
  };

  const toggleTaskCompletion = (index) => {
    const updatedTasks = [...tasks];
    updatedTasks[index].completed = !updatedTasks[index].completed;
    setTasks(updatedTasks);
  };

  const handleActiveTask = () => {
    if (activeNewTask.trim() === "") return;
    setActiveNewTask([
      ...activeNewTask,
      { activeTask: activeNewTask, completed: false },
    ]);
  };
  const handleDeleteTask = (index) => {
    const updatedTasks = tasks.filter((_, idx) => idx !== index);
    setTasks(updatedTasks);
  };
  const handleChangePath = () => {
    navigate("/workflow-orderEntry");
  };

  // const patientDetails = [
  //   {
  //     name: "John, David",
  //     dob: "01/08/1996",
  //     phone: "(555) 123-4567",
  //     prescriberName: "Smith, Robert",
  //     officeAddess: "1234cMaple Rd,Anytown,USA",
  //     officePhone: "(555) 123-4567",
  //     medication: "Venlafaxine ER Tablet 150MG",
  //     daw: "0-Not specified",
  //     quantity: "30 EA",
  //     direction: "Take 1 tablet by mouth",
  //     refills: "05",
  //     dateWritten: "12/19/2024",
  //     notes: "Please contact the office to report any insurance issues",
  //     signature: "Robert Smith.MD at 12/19/2024, 1:02 PM EST",
  //   },
  // ];

  const togglebtnOne = (id) => {
    if (openOne === id) {
      setOpenOne();
    } else {
      setOpenOne(id);
    }
  };

  const togglebtnTwo = (id) => {
    if (openTwo === id) {
      setOpenTwo();
    } else {
      setOpenTwo(id);
    }
  };

  const togglebtnThree = (id) => {
    if (openThree === id) {
      setOpenThree();
    } else {
      setOpenThree(id);
    }
  };

  // const handleClickStatus = () => {
  //   setOpenStatus((prevState) => !prevState);
  // };
  const togglePatientDetails = (id) => {
    if (openPatinetsDetails === id) {
      setOpenPatinetsDetails();
    } else {
      setOpenPatinetsDetails(id);
    }
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleInputChange = (e) => {
    setSearchTermDrug(e.target.value);
  };

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleBlur = () => {
    setFocusedInput("");
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };
  const handleEndDate = (endDate) => {
    if (startDate !== null) {
      const date = moment(endDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setEndDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setEndDate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleEndDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && endDate !== null) {
      setEndDate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleEndDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };
  const stepNum = 2;
  const numSteps = 9;
  const step = [
    { title: "Patient", time: "13:21", date: "02/06/2025" },
    { title: "Patient", time: "13:21", date: "02/06/2025" },
  ];

  return (
    <>
      <Container fluid className="bg-white p-3" style={{ width: "84vw" }}>
        <Container fluid>
          <Container fluid>
            {openStatus && (
              <div className="popup-status-partent">
                <div className="popup-status">
                  <div className="stepper-horizontal " id="stepper1">
                    {Array.from({ length: numSteps }, (_, index) => {
                      const stepNum = index + 1;
                      return (
                        <div
                          className={`step 
                        ${stepNum === currentStep ? "editing fffff" : ""}
                         ${stepNum < currentStep ? "done" : ""}`}
                          key={stepNum}
                        >
                          <div className="step-circle">
                            <span>{stepNum}</span>
                          </div>
                          <div>
                            {stepNum === 1 ? (
                              <>
                                <div className="step-title">Patient </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 2 ? (
                              <>
                                <div className="step-title">E-Rx </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 3 ? (
                              <>
                                <div className="step-title">Order Entry </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 4 ? (
                              <>
                                <div className="step-title">Dur </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 5 ? (
                              <>
                                <div className="step-title">Claim Details </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 6 ? (
                              <>
                                <div className="step-title">
                                  Initial Review{" "}
                                </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 7 ? (
                              <>
                                <div className="step-title">Packaging </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : stepNum === 8 ? (
                              <>
                                <div className="step-title">Final Review </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="step-title">Sales </div>
                                <div className="step-desc">
                                  <div className="step-time">13:21, </div>
                                  <div className="step-time">
                                    {" "}
                                    02/06/2025
                                  </div>{" "}
                                </div>
                              </>
                            )}
                          </div>

                          {/* Only show content for the active step */}

                          <div className="step-bar-left"></div>
                          <div className="step-bar-right"></div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </Container>
          <Container fluid>
            <PatientsDemographic
              fullName={rowData.patient}
              // firstName={rowData.patient.split(" ")[0].replace(",", "")}
              // lastName={rowData.patient.split(" ")[1]}
              // dob={namesData.dob}
              // phone={namesData.phone}
            />
          </Container>
          <Container fluid className="logo-drawer mb-8">
            <Row>
              <Col className="d-flex justify-content-start gap-2">
                <div
                  style={{ opacity: !drugUtil ? "0.4" : "" }}
                  onClick={drugUtil ? () => setDrugUtil(true) : null}
                  id="ScheduleUpdateTooltip"
                >
                  <HoverImage
                    className="drug-status"
                    src={drugPurpleIcon}
                    hoverSrc={drugLightIcon}
                    alt=""
                  />
                  <UncontrolledTooltip
                    disabled
                    placement="bottom"
                    target="ScheduleUpdateTooltip"
                    trigger="hover"
                  >
                    Drug Utilization Review
                  </UncontrolledTooltip>
                </div>
                <div
                  style={{ opacity: !claimsInfo ? "0.4" : "" }}
                  onClick={claimsInfo ? () => setClaimsInfo(true) : null}
                  id="ScheduleUpdateTooltip2"
                >
                  <HoverImage
                    className="drug-status"
                    src={drugList}
                    hoverSrc={drugWhite}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip2"
                    trigger="hover"
                  >
                    Claims Information
                  </UncontrolledTooltip>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => setMsgInfo(!msgInfo)}
                  id="ScheduleUpdateTooltip3"
                >
                  <HoverImage
                    src={MessageIconDark}
                    className="drug-status"
                    hoverSrc={MessageIconLight}
                    alt=""
                  />
                  <UncontrolledTooltip
                    // className="tooltip-custom"
                    style={{ position: "relative", left: "30px" }}
                    placement="bottom"
                    target="ScheduleUpdateTooltip3"
                    trigger="hover"
                  >
                    Comments
                  </UncontrolledTooltip>
                </div>
                <div className="comment">
                  <img src={completeIcon} alt="not available" />
                  340B Eligible
                </div>
              </Col>
              <Col className="d-flex justify-content-end ">
                <Button color="primary" className="reset">
                  <img src={patientProfile} /> Patient Profile
                </Button>
                <Button className="back-button primary">
                  {" "}
                  <img src={rxHistory} />
                  Rx History
                </Button>
                <Dropdown
                  isOpen={dropdownOpen}
                  toggle={toggle}
                  style={{ marginLeft: "12px" }}
                >
                  <DropdownToggle color="primary" className="togglebtn">
                    {dropdownOpen ? (
                      <img src={closeIcon} alt="icon" />
                    ) : (
                      <img src={threeDotsIcon} alt="icon" />
                    )}
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem className="dropdownitem-border">
                      <img src={plusIcon} /> Add Notes
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Print
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> E-Rx Details{" "}
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Forward Rx
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Due
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> P/A
                    </DropdownItem>
                    <DropdownItem className="dropdownitem-border">
                      {" "}
                      <img src={uploadIcon} /> Rx History
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </Col>
            </Row>
          </Container>
          <Container fluid>
            <Row className="fixedHeight">
              <div className="">
                <Formik>
                  <Accordion open={openOne} toggle={togglebtnOne}>
                    <AccordionItem>
                      <AccordionHeader targetId="1">
                        Order Details
                        <span className="order-details">
                          <img src={orderDetailsIcon} /> - $5.70
                        </span>
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <Row>
                          <Col md={6}>
                            <h2 className="heading-pres">
                              New E- Prescription
                            </h2>
                            <div
                              style={{
                                backgroundColor: "#F7F7F7",
                                borderTop: "1px solid #D3D3D3",
                                padding: "8px",
                              }}
                            >
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      {" "}
                                      <div className="pdetails">
                                        Patient Name:
                                      </div>
                                    </Col>

                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        {rowData.patient}
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Birth Date:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        {/* {rowData.dob} */}
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">Phone:</div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        (555) 987-6543
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <div className="divider-pre"></div>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Prescriber Name:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        Smith, Robert
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Office Address:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div
                                        style={{ fontSize: "16px" }}
                                        className="final-review-value"
                                      >
                                        1234 Maple Rd, Anytown, USA
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Office Phone:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        (555) 987-6543
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Date Written:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        12/19/2024
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <div className="divider-pre"></div>

                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Medication:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        Venlafaxine ER Tablet 150MG
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">DAW:</div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div
                                        style={{ fontSize: "16px" }}
                                        className="final-review-value"
                                      >
                                        0-Not Specified
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">Quantity:</div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        30 EA
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Directions:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div
                                        style={{ fontSize: "16px" }}
                                        className="final-review-value"
                                      >
                                        Take 1 tablet by mouth Daily
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">Refills:</div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        5
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">
                                        Electronic Signature:
                                      </div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        Robert Smith. MD at 12/19/2024, 1:02 PM
                                        EST.
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <Row>
                                    <Col sm={6} md={5} lg={5}>
                                      <div className="pdetails">Note:</div>
                                    </Col>
                                    <Col sm={6} md={7} lg={7}>
                                      <div className="final-review-value">
                                        Please contact the office to report any
                                        insurance issues
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col md={6}>
                            <h2 className="heading-pres">Order Entry </h2>
                            <div
                              style={{
                                borderTop: "1px solid #D3D3D3",
                                // padding: "8px",
                              }}
                            >
                              <Row>
                                <Col sm={12} md={6} className="required-date ">
                                  <Label className="order-entry-details">
                                    Date Written
                                  </Label>
                                  <InputGroup
                                    onMouseLeave={handleMouseLeave}
                                    className="date-14px"
                                  >
                                    <DatePicker
                                      id="startDate"
                                      name="startDate"
                                      selected={startDate}
                                      onChange={(startDate) =>
                                        handleStartDate(startDate)
                                      }
                                      onFocus={() => handleFocus("StartDate")}
                                      onBlur={handleBlur}
                                      isClearable
                                      onChangeRaw={handleStartDateRaw}
                                      dateFormat="MM/dd/yyyy"
                                      placeholderText="MM/DD/YYYY"
                                      autoComplete="off"
                                      customInput={
                                        <ReactInputMask
                                          mask="99/99/9999"
                                          value={startDate}
                                        />
                                      }
                                    />
                                    <InputGroupText
                                      onClick={() =>
                                        handleDateClick("startDate")
                                      }
                                    >
                                      <img src={Calendar} alt="" />
                                    </InputGroupText>
                                  </InputGroup>
                                </Col>
                                <Col sm={12} md={6} className="required-date ">
                                  <Label className="order-entry-details">
                                    Dispense Date
                                  </Label>
                                  <InputGroup
                                    onMouseLeave={handleMouseLeave}
                                    className="date-14px"
                                  >
                                    <DatePicker
                                      id="endDate"
                                      name="endDate"
                                      selected={endDate}
                                      onChange={(endDate) =>
                                        handleEndDate(endDate)
                                      }
                                      onFocus={() => handleFocus("endDate")}
                                      onBlur={handleBlur}
                                      isClearable
                                      onChangeRaw={handleEndDateRaw}
                                      dateFormat="MM/dd/yyyy"
                                      placeholderText="MM/DD/YYYY"
                                      autoComplete="off"
                                      customInput={
                                        <ReactInputMask
                                          mask="99/99/9999"
                                          value={endDate}
                                        />
                                      }
                                    />
                                    <InputGroupText
                                      onClick={() => handleDateClick("endDate")}
                                    >
                                      <img src={Calendar} alt="" />
                                    </InputGroupText>
                                  </InputGroup>
                                </Col>
                              </Row>
                              <Row>
                                <FormGroup className="controls textarea_info search-flex mb-0">
                                  <Label className="order-entry-details">
                                    Medication
                                  </Label>
                                  <InputGroup>
                                    <Input
                                      // className="required"
                                      type="text"
                                      name="medication"
                                      value={searchTermPrescriber.medication}
                                      onChange={handleInputChangePrescriber}
                                      placeholder="Search by Prescriber Name"
                                    />
                                    {searchTermPrescriber.medication ? (
                                      <button
                                        onClick={() =>
                                          clearSearch("medication")
                                        }
                                        className="clearButton"
                                      >
                                        &#x2715;{" "}
                                        {/* Unicode for the "x" symbol */}
                                      </button>
                                    ) : (
                                      <img src={searchGrayIcon} />
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Row>
                              <Row>
                                <FormGroup className="controls textarea_info search-flex mb-0">
                                  <Label className="order-entry-details">
                                    Prescriber
                                  </Label>
                                  <InputGroup>
                                    <Input
                                      // className="required"
                                      type="text"
                                      name="prescriber"
                                      value={searchTermPrescriber.prescriber}
                                      onChange={handleInputChangePrescriber}
                                      placeholder="Search by Product Name"
                                    />
                                    {searchTermPrescriber.prescriber ? (
                                      <button
                                        onClick={() =>
                                          clearSearch("prescriber")
                                        }
                                        className="clearButton"
                                      >
                                        &#x2715;{" "}
                                        {/* Unicode for the "x" symbol */}
                                      </button>
                                    ) : (
                                      <img src={searchGrayIcon} />
                                    )}
                                  </InputGroup>
                                </FormGroup>
                              </Row>
                              <Row>
                                <FormGroup className="controls mb-0">
                                  <Label className="order-entry-details">
                                    Directions
                                  </Label>
                                  <Input
                                    style={{ border: "1px soild" }}
                                    className="textlength"
                                    name="directions"
                                    type="textarea"
                                    value={directions}
                                    onChange={handleChangeDirections}
                                    placeholder="Enter Directions"
                                  />
                                </FormGroup>
                              </Row>
                              <Row>
                                <Col sm={12} md={4}>
                                  <FormGroup className="controls textarea_info search-flex mb-0 ">
                                    <Label className="order-entry-details">
                                      Quantity
                                    </Label>
                                    <InputGroup>
                                      <Input
                                        setcss="required"
                                        type="number"
                                        value={quantity}
                                        onChange={(e) =>
                                          setQuantity(e.target.value)
                                        }
                                        autoComplete="off"
                                        placeholder="30"
                                      />
                                    </InputGroup>
                                  </FormGroup>
                                </Col>
                                <Col sm={12} md={4}>
                                  <FormGroup className="controls textarea_info search-flex mb-0">
                                    <Label className="order-entry-details">
                                      Day Supply
                                    </Label>
                                    <InputGroup>
                                      <Input
                                        setcss="required"
                                        type="number"
                                        autoComplete="off"
                                        placeholder="5"
                                        value={daySupply}
                                        onChange={(e) =>
                                          setDaySupply(e.target.value)
                                        }
                                      />
                                    </InputGroup>
                                  </FormGroup>
                                </Col>
                                <Col sm={12} md={4}>
                                  <FormGroup className="controls textarea_info search-flex mb-0">
                                    <Label className="order-entry-details">
                                      Refill
                                    </Label>
                                    <InputGroup>
                                      <Input
                                        setcss="required"
                                        type="number"
                                        autoComplete="off"
                                        placeholder="0"
                                        value={refills}
                                        onChange={(e) =>
                                          setRefills(e.target.value)
                                        }
                                      />
                                    </InputGroup>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Formik>
                <Formik>
                  <Accordion
                    open={openTwo}
                    toggle={togglebtnTwo}
                    className="mt-1"
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="1">
                        Payment / Insurance (2)
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <Row>
                          <Col>
                            <h2 className="heading-pres">Add Insurance</h2>
                            <div
                              className="bg-light p-8 "
                              style={{ borderTop: "1px solid #D3D3D3" }}
                            >
                              <FormGroup>
                                <InputGroup className="bg-white">
                                  <Input
                                  
                                    type="text"
                                    value={newTask}
                                    onChange={(e) => setNewTask(e.target.value)}
                                    placeholder="Search by Payer, BIN or PCN"
                                    className="bg-light"
                                  />
                                  <div
                                    onClick={handleAddTask}
                                    className="add-new-plan"
                                  >
                                    <img src={plusPurple} alt="" />
                                    <span>Add New Plan</span>
                                  </div>
                                </InputGroup>
                              </FormGroup>
                              {tasks.map((task, index) => (
                                <div
                                  key={task.id}
                                  className="d-flex justify-content-between gap-2  mb-2"
                                >
                                  <div className="plan-card">{task.task}</div>
                                  <Button
                                    color="primary"
                                    className="submit"
                                    style={{ width: "20%" }}
                                    onClick={() => handleMove(task.id)}
                                  >
                                    <img src={plusIcons} />
                                    Add
                                  </Button>
                                </div>
                              ))}
                            </div>
                          </Col>
                          <Col>
                            <h2 className="heading-pres">Active Plans</h2>
                            <Row style={{ borderTop: "1px solid #D3D3D3" }}>
                              <div>
                                {movedData.map((name) => (
                                  <div
                                    className="d-flex justify-content-between mt-2"
                                    style={{ gap: "10px" }}
                                  >
                                    <div className="bg-light active-plan-box">
                                      <div>
                                        <span className="active-plan">
                                          {/* State Medicaid (Secondary) */}
                                          {name.task}
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "14px",
                                            paddingLeft: "8px",
                                            fontWeight: "600",
                                            color: "#757575",
                                          }}
                                        >
                                          BIN:098677. PCN:S...
                                        </span>
                                      </div>
                                      <img src={dubbleArrow} />
                                    </div>
                                    <div className="d-flex justify-content-end">
                                      <Button className="back-button">
                                        <img src={eidtPurpleIcon} />
                                      </Button>
                                      <Button
                                        color="primary"
                                        onClick={() => handleDelete(name.id)}
                                      >
                                        <img src={deleteIcon} />
                                      </Button>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Row>
                          </Col>
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Formik>
                <Formik>
                  <Accordion
                    open={openThree}
                    toggle={togglebtnThree}
                    className="mt-1"
                    style={{ marginBottom: "30px" }}
                  >
                    <AccordionItem>
                      <AccordionHeader targetId="1">
                        Other Details
                      </AccordionHeader>
                      <AccordionBody accordionId="1">
                        <Row>
                          <Col sm={12} md={3} className="inc">
                            <FormGroup className="controls textarea_info search-flex mb-0 ">
                              <Label className="order-entry-details">
                                Total Quantity Written
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  value={increment.totalQtyWritten}
                                  name="totalQtyWritten"
                                  onChange={handleChangeIncrement}
                                  placeholder="Enter Quantity"
                                />
                                <InputGroupText>
                                  <div className="d-flex flex-column">
                                    {" "}
                                    <img
                                      src={upArrow}
                                      onClick={handleIncrement}
                                    />
                                    <img
                                      src={downArrow}
                                      onClick={handleDecrement}
                                    />
                                  </div>
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3}>
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <Label className="order-entry-details">
                                Diagnosis Code
                              </Label>
                              <InputGroup>
                                <Input
                                  setcss="required"
                                  type="text"
                                  name="dignosis"
                                  value={searchTermPrescriber.dignosis}
                                  onChange={handleInputChangePrescriber}
                                  placeholder="Search by Diagnosis Code "
                                />

                                {searchTermPrescriber.dignosis ? (
                                  <button
                                    onClick={() => clearSearch("dignosis")}
                                    className="clearButton"
                                  >
                                    &#x2715; {/* Unicode for the "x" symbol */}
                                  </button>
                                ) : (
                                  <img src={searchGrayIcon} />
                                )}
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3} className="required-date ">
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <Label className="order-entry-details">
                                Do Not Fill Until
                              </Label>
                              <InputGroup onMouseLeave={handleMouseLeave}>
                                <DatePicker
                                  id="startDate"
                                  name="startDate"
                                  selected={startDate}
                                  onChange={(startDate) =>
                                    handleStartDate(startDate)
                                  }
                                  onFocus={() => handleFocus("StartDate")}
                                  onBlur={handleBlur}
                                  isClearable
                                  onChangeRaw={handleStartDateRaw}
                                  dateFormat="MM/dd/yyyy"
                                  placeholderText="MM/DD/YYYY"
                                  autoComplete="off"
                                  customInput={
                                    <ReactInputMask
                                      mask="99/99/9999"
                                      value={startDate}
                                    />
                                  }
                                />
                                <InputGroupText
                                  onClick={() => handleDateClick("startDate")}
                                >
                                  <img src={Calendar} alt="" />
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3}>
                            <Label className="order-entry-details">
                              Treatment Type
                            </Label>
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <InputGroup>
                                <Field
                                  as="select"
                                  name="option"
                                  id="option"
                                  value={setSelectedOptions.option1}
                                  onChange={handleChangeOption}
                                  // className="form-control"
                                >
                                  <option value="" label="Select Type" />
                                  <option value="option1" label="Option 1" />
                                  <option value="option2" label="Option 2" />
                                  <option value="option3" label="Option 3" />
                                </Field>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={12} md={3} className="inc">
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <Label className="order-entry-details">
                                Serial Number
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  // value={increment.serialNo}
                                  name="serialNo"
                                  // onChange={handleChangeIncrement}
                                  placeholder="Enter Serial Number"
                                />
                                <InputGroupText>
                                  <div className="d-flex flex-column">
                                    {" "}
                                    {/* <img src={upArrow} onClick={handleIncrement} />
                              <img src={downArrow} onClick={handleDecrement} /> */}
                                  </div>
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3}>
                            <Label className="order-entry-details">DAW</Label>
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <InputGroup>
                                <Field
                                  as="select"
                                  name="option"
                                  id="option"
                                  className="order-detail-input"
                                  value={setSelectedOptions.option2}
                                  onChange={handleChangeOption}
                                  // className="form-control"
                                >
                                  <option value="" label="Select DAW" />
                                  <option value="option1" label="Option 1" />
                                  <option value="option2" label="Option 2" />
                                  <option value="option3" label="Option 3" />
                                </Field>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3} className="inc">
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <Label className="order-entry-details">
                                Partial Fill QTY
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  value={increment.partialFillQty}
                                  name="partialFillQty"
                                  onChange={handleChangeIncrement}
                                  placeholder="Enter Quantity"
                                />
                                <InputGroupText>
                                  <div className="d-flex flex-column">
                                    {" "}
                                    <img
                                      src={upArrow}
                                      onClick={handleIncrement}
                                    />
                                    <img
                                      src={downArrow}
                                      onClick={handleDecrement}
                                    />
                                  </div>
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col sm={12} md={3}>
                            <FormGroup className="controls textarea_info search-flex mb-0">
                              <Label className="order-entry-details">
                                Partial Fill Days Supply
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  value={increment.partialFillDaySupply}
                                  name="partialFillDaySupply"
                                  onChange={handleChangeIncrement}
                                  placeholder="Enter Quantity"
                                />
                                <InputGroupText>
                                  <div className="d-flex flex-column">
                                    {" "}
                                    <img
                                      src={upArrow}
                                      onClick={handleIncrement}
                                    />
                                    <img
                                      src={downArrow}
                                      onClick={handleDecrement}
                                    />
                                  </div>
                                </InputGroupText>
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </AccordionBody>
                    </AccordionItem>
                  </Accordion>
                </Formik>
              </div>
            </Row>
          </Container>
        </Container>
      </Container>
      <div>
        <Offcanvas
          // style={{ width: "83vw" }}
          isOpen={claimInformation}
          toggle={() => {
            setClaimInformation(!claimInformation), setRowDetails(false);
          }}
          direction="end"
        >
          <div className="d-flex justify-content-between flex-column ">
            <div>
              <div className="casvas-header">
                <div>Claims Information (Rx-6152657) </div>

                <div
                  className="cursor-pointer"
                  onClick={() => setClaimInformation(false)}
                >
                  <img src={CloseIcon} />
                </div>
              </div>

              <div
                className="section-devider-border"
                style={{
                  margin: "0px 12px 15px 18px",
                }}
              ></div>
              <OffcanvasBody>
                <ClaimInformation
                  expand={expand}
                  setExpand={setExpand}
                  setClaimInformation={setClaimInformation}
                />
              </OffcanvasBody>
            </div>
            <div>
              <div
                style={{
                  // padding: "8px",
                  width: expand ? "82vw" : "50vw",
                  height: "auto",
                }}
                className="d-flex justify-content-between p-3 bg-light"
                onClick={() => setClaimInformation(false)}
              >
                <div>
                  {" "}
                  <Button className="reset" color="primary">
                    <img src={plusIcon}/>Add to Prescriber Calls
                  </Button>
                </div>
                <div className="d-flex justify-content-between gap-2">
                  <div>
                    <Button className="back-button">Start P/A</Button>
                  </div>
                  <div>
                    <Button color="primary">
                      {" "}
                      <img src={aknowledgeIcon} />
                      Resubmit Claim
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Offcanvas>
        <Drawer
          direction="end"
          size="lg"
          isOpen={msgInfo}
          toggle={() => setMsgInfo(!msgInfo)}
          title="Chat"
        >
          <Chating />
        </Drawer>
      </div>
    </>
  );
};
export default ClaimsOrderDetails;
